import { CHANGELOG } from '../changelog';

export function Changelog() {
  return (
    <>
      <div className="page-header">
        <h1>Change Log</h1>
      </div>

      <div className="changelog-list">
        {CHANGELOG.map((release) => (
          <div className="card changelog-release" key={release.version}>
            <div className="changelog-release-header">
              <span className="changelog-version-badge">v{release.version}</span>
              <span className="muted">{release.date}</span>
            </div>
            <div className="changelog-release-entries">
              {release.entries.map((entry) => (
                <div className="changelog-entry" key={entry.title}>
                  <h3>{entry.title}</h3>
                  <ul className="simple-list changelog-items">
                    {entry.items.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
